import * as React from 'react'
export const FacebookIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1752_1846)'>
        <path
          d='M11.3068 -0.171875C10.6747 -0.171875 10.0668 -0.0957232 9.35729 0.1835C7.91548 0.766061 7.18062 2.13425 7.18062 4.26397V6.34291H5.15625V9.81543H7.18062V19.8281H11.3068V9.81416H14.1168L14.4975 6.34291H11.3068V4.77038C11.3068 4.28935 11.3575 3.93398 11.4845 3.73217C11.6622 3.42757 12.0163 3.27526 12.5722 3.27526H14.4455V-0.171875H11.3068Z'
          fill='current'
        />
      </g>
      <defs>
        <clipPath id='clip0_1752_1846'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
